import {convertUserName} from './convertUserName';

export function withUserName<T extends {firstName: string; lastName: string}>(model: T) {
  const {firstName, lastName} = model;

  return {...model, name: convertUserName(firstName, lastName)};
}
